module.exports = __webpack_public_path__ + "static/media/kerberos.63a3b808.jpg";